//-- Expose +State
import * as SharedActions from './lib/+state/actions/shared.actions';
import * as SharedFeature from './lib/+state/reducer/shared.reducer';
import { AnalyticsData } from './lib/models/analytics';

export * from './lib/+state/models/shared.models';
export * from './lib/+state/state.facade';
//-- Expose Errors Utils
export * from './lib/adapters/error.adapter';
export * from './lib/adapters/full-page-error.adapter';
//-- Expose Notification
export * from './lib/components/notification/index';
//-- Expose Card
export * from './lib/components/card/card.component';
export * from './lib/components/card/card.module';
export * from './lib/components/card/mocks/card.mocks';
export * from './lib/components/card/models/card.interfaces';
//-- Expose Content Expander
export * from './lib/components/content-expander/content-expander.component';
export * from './lib/components/content-expander/content-expander.module';
export * from './lib/components/content-expander/mocks/content-expander.mocks';
export * from './lib/components/content-expander/models/content-expander.interfaces';
//-- Paginator
export * from './lib/components/paginator/paginator.component';
export * from './lib/components/paginator/paginator.module';
//-- Expose Partners
export * from './lib/components/partners/adapters/partners.adapter';
export * from './lib/components/partners/mocks/index';
export * from './lib/components/partners/models/index';
export * from './lib/components/partners/partners.component';
export * from './lib/components/partners/partners.module';
//-- Expose Related Links
export * from './lib/components/related-links/adapters/related-links.adapter';
export * from './lib/components/related-links/mocks/related-links.mocks';
export * from './lib/components/related-links/models/related-links.interfaces';
export * from './lib/components/related-links/related-links.component';
export * from './lib/components/related-links/related-links.module';
//- Expose Terms and Conditions
export * from './lib/components/stipulation/mocks/stipulations.mocks';
export * from './lib/components/stipulation/models/stipulation.interface';
export * from './lib/components/stipulation/stipulation.component';
export * from './lib/components/stipulation/stipulation.module';
//-- Overview Summary
export * from './lib/components/summary/mocks/summary.mocks';
export * from './lib/components/summary/models/summary.models';
export * from './lib/components/summary/summary.component';
export * from './lib/components/summary/summary.module';
export * from './lib/components/welcome-tour/mocks/welcome-tour-tracker.mocks';
//-- Welcome Tour
export * from './lib/components/welcome-tour/mocks/welcome-tour.mocks';
export * from './lib/components/welcome-tour/models/welcome-tour.interfaces';
export * from './lib/components/welcome-tour/welcome-tour.component';
export * from './lib/components/welcome-tour/welcome-tour.module';
//-- Expose Mocks
export * from './lib/mocks/index';
//-- Expose Models
export * from './lib/models/index';
//-- Expose services
export * from './lib/services/index';
//-- Expose Module
export * from './lib/shared.module';
//-- Expose Utils
export * from './lib/utils/index';
//-- Expose +State
//-- Expose Pipes
export * from './lib/components/medallion-banner/components/details/details.component';
export * from './lib/components/medallion-banner/components/status/status.component';
export * from './lib/components/medallion-banner/index';
export * from './lib/components/medallion-banner/medallion-banner.component';
export * from './lib/components/medallion-banner/models/medallion-banner.interfaces';
export * from './lib/pipes/index';

export { SharedActions, SharedFeature };

export type DataLayerWindow = Window & {
  adobeDataLayer: AnalyticsData[];
};
